import ObjectModelProperty from "../../models/objectModelProperties/objectModelProperty";
import {ObjectModelPropertyType} from "../../enums/objectModelPropertyType";
import ObjectModel from "~/models/objectModel";
import disabledMixin from '~/mixins/disabledMixin'
import ObjectModelEntry from '~/models/objectModelEntries/objectModelEntry'
import {Hash} from '~/interfaces/hashInterfaces'

export default {
  mixins: [
    disabledMixin,
  ],
  data() {
    return {
      initialValue: this.value
    }
  },
  props: {
    entry: {
      type: Object as () => ObjectModelEntry,
      required: false
    },
    objectModel: {
      type: Object as () => ObjectModel,
      required: true
    },
    propertyClientId: {
      type: String,
      required: true,
    },
    labelTitle: {
      type: String
    },
    isDetailViewEdit:{
      type: Boolean,
      default: false
    },
    formatAsPercentage: { // NOTE: Hopefully temporary solution whilst OM Number Props do not have Percentage format
      type: Boolean,
      default: false,
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isEditedField(){
      return this.initialValue !== this.value
    },
    objectModelProperty(): ObjectModelProperty {
      return this.objectModel.object_model_properties[this.propertyClientId];
    },
    objectModelPropertyType(): ObjectModelPropertyType {
      return this.objectModelProperty.property_type;
    },
    commonEntriesPropertiesCssClasses(): Hash<boolean> {
      return {
        'edited-entry-form-field': this.isDetailViewEdit && this.isEditedField,
        disabled: this.disabled,
      }
    },
  },
}